import { Picker, Modal } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';

import './MyOrder.less';

var formatTime = util.formatTime
let weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

export default class MyOrder extends OfficialPage {
  state = {
    existGoodsIndex: 0,
    existGoodsType: [],
    currentGoodsType: '',
    orderLists: [],
    pages: 1,
    hiddenmodalput: true,
    untimes: '', // 次数券的次数
    numberOfStampsUrl: '',
    addLabelText: '',
    transportStatus: {
      0: '待创建',
      1: '待骑手接单',
      2: '骑手已接单', //蜂鸟已分配骑手
      3: '骑手配送中',
      4: '骑手配送已完成',
      5: '已取消',
      7: '已过期',
      8: '指派单',
      9: '妥投异常之物品返回中',
      10: '妥投异常之物品返回完成',
      11: '骑手已到店',
      12: '申请取消配送',
      1000: '订单异常'
    },
    noMore: false,
    currentTabIndex: 0,
    goodsTypeList: [],
    isFromBack: false,
    marker: [
      {
        latitude: 0,
        longitude: 0,
        iconPath: '/images/transport.png',
        width: 75,
        height: 75
      }
    ],
    toStoreSetting: '',
    showWriteOffCodeBox: false,
    goodsOrderStatusName: [
      '待付款',
      '待发货',
      '待收货',
      '待评价',
      '退款审核中',
      '正在退款中',
      '已完成',
      '已关闭',
      '待接单',
      '',
      '',
      '',
      '',
      '',
      '',
      '退款失败'
    ],
    showGoodsPickBox: false,
    selectGoodsPickIndex: '',
    selectGoodsPickIndex: 0,
    dayList: ['今天', '明天', '后天']
  }
  goodsType = [
    {
      type: 0,
      name: '基础'
    },
    {
      type: 1,
      name: '预约'
    },
    {
      type: 2,
      name: '外卖'
    },
    {
      type: 3,
      name: '到店'
    },
    {
      type: 5,
      name: '当面付'
    },
    {
      type: 6,
      name: '排号'
    },
    {
      type: 8,
      name: '购卡'
    },
    {
      type: 9,
      name: '兑换券'
    },
    {
      type: 10,
      name: '行业预约'
    },
    {
      type: 21,
      name: '社区团购'
    }
  ]
  types = {
    // 只有一种商品订单时，types保存商品订单的五个分类
    0: [undefined, 0, 1, 2, 3, [8, 16], 6, 7, 17], // 电商
    1: [undefined, 0, 1, 2, 3], // 预约
    2: [undefined, 0, 6, 7], // 外卖
    3: [undefined, 0, 1, 2, 3, 'refund_status', 7], // 到店
    5: [undefined, 0, 6, 7], // 当面付
    6: [undefined, 2, 6, 7], //排号
    10: [undefined, 0, 1, 2, 3],
    9: [undefined, 0, 1, 7], // 其他（兑换券）
    8: [undefined, 0, 1, 7], // 其他（购卡）
    21: [undefined, 0, 1, 2, 10, 3] //社区团购
  }
  verifiTimeInterval = ''

  constructor(props) {
    super(props);
    document.title = '订单列表';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    if (options.goodsType && options.currentIndex) {
      this.setData({
        currentGoodsType: options.goodsType,
        currentTabIndex: options.currentIndex
      })
    }
    this.setData({
      franchiseeIdInfo: {
        id: options.franchisee || ''
      }
    })
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      this.setData({
        pages: 1,
        currentTabIndex: this.data.currentTabIndex,
        noMore: false
      })
      this.getOrderList({ tabIndex: this.data.currentTabIndex })
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  dataInitial = () => {
    var _this = this
    this.getTakeOutInfo()
    this.getAppECStoreConfig()
    this.getOrderList({
      tabIndex: _this.data.currentTabIndex,
      firstLoad: true
    })
  }
  getOrderList = param => {
    var that = this,
      data = {
        page: that.data.pages,
        page_size: 25
      },
      type
    var good_type = this.data.currentGoodsType
    if (this.data.currentGoodsType !== '') {
      data.screening_cond = {}
      type = this.types[good_type] && this.types[good_type][param.tabIndex]
      if (type != undefined) {
        data.screening_cond.status = type
      }
      if (good_type == 0) {
        data.screening_cond.is_distribution_order = ''
        data.screening_cond.pick_up_type =
          this.data.selectGoodsPickIndex == 0
            ? ''
            : this.data.selectGoodsPickIndex
      }
      data.screening_cond.order_id = this.data.searchOrderId || ''
      if (good_type == 21) {
        good_type = 0
        data.screening_cond.is_distribution_order = 2
      }
      data.goods_type = good_type
      if (data.goods_type == 10 && type == null) {
        data.idx_arr = {
          idx_value: ''
        }
      }
    } else {
      data.screening_cond = {
        is_distribution_order: ''
      }
    }
    data.parent_shop_app_id = app.getAppId() // 获取订单列表时 传parent_shop_app_id获取本店以及所有子店的订单
    data.not_get_takeout = 1 //不获取店铺信息（在getTakeOutInfo请求）
    if (param.firstLoad && this.data.currentGoodsType == '') {
      data.use_default_goods_type = 1
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/orderList',
      method: 'post',
      data: data,
      success: function(res) {
        let data = {},
          orders = res.data
        for (var i = orders.length - 1; i >= 0; i--) {
          var formData = orders[i].form_data
          if (
            formData.appointment_order_info &&
            formData.appointment_order_info.appointment_unit_type == '6'
          ) {
            formData.timeDiff =
              Date.parse(new Date()) -
                Date.parse(new Date(formData.appointment_time.split('~')[1])) >
              0
                ? true
                : false
          } else {
            formData.timeDiff = false
          }
          if (formData.tostore_data && formData.tostore_data.appointed_time) {
            formData.tostore_data.appointed_time = formData.tostore_data.appointed_time.substr(
              11,
              5
            )
          }
          if (
            formData.goods_type == 2 &&
            formData.status == 2 &&
            formData.take_out_info.deliver_type != 0 &&
            formData.take_out_info.deliver_type != '' &&
            (formData.take_out_transport_order.status == 2 ||
              formData.take_out_transport_order.status == 3 ||
              formData.take_out_transport_order.status == 11)
          ) {
            that.getTransportInfo(formData.order_id, i)
          }
          if (formData.goods_type == 8 && formData.goods_info.num) {
            formData.goods_info.cNum = that.NumberToChinese(
              formData.goods_info.num
            )
          }
          if (formData.goods_type == 2) {
            let goodNum = 0
            for (let j = 0; j < formData.goods_info.length; j++) {
              goodNum += +formData.goods_info[j].num
            }
            data['goodsNum'] = goodNum
          }
          let newAppointmentData = {}
          if (formData.goods_type == 10) {
            if (formData.service.is_hotel_appointment) {
              let service = formData.service,
                interval = service.hotel_appointment[0],
                now_day = service.now_date,
                start_time = new Date(interval.start_time * 1000),
                end_time = new Date(interval.end_time * 1000)
              newAppointmentData.title = formData.goods_info[0].goods_name
              newAppointmentData.cover = formData.goods_info[0].cover
              newAppointmentData.standard = interval.elem_type
              newAppointmentData.count = interval.long
              newAppointmentData.start_date = `${start_time.getMonth() +
                1}月${start_time.getDate()}日`
              newAppointmentData.end_date = `${end_time.getMonth() +
                1}月${end_time.getDate()}日`
              newAppointmentData.start_day =
                that.data.dayList[
                  Math.floor((interval.start_time - now_day) / 86400)
                ] || weekArr[start_time.getDay()]
              newAppointmentData.end_day =
                that.data.dayList[
                  Math.floor((interval.end_time - now_day) / 86400)
                ] || weekArr[end_time.getDay()]
              newAppointmentData.phone = service.new_appointment_user_phone
              newAppointmentData.endDate = formatTime(end_time).slice(0, 10)
              formData.newAppointmentData = newAppointmentData
            } else {
              newAppointmentData = {
                serveInfo: [],
                toStoreTime: '',
                toStoreTimeEnd: '',
                duration: '',
                providerList: [],
                providerTitle: '',
                form: 2
              }
              let new_appointment = formData.service.new_appointment,
                doc_info = new_appointment.doc_info,
                elem_info = new_appointment.elem_info,
                worker_info = new_appointment.worker_info
              for (let i = 0; i < doc_info.length; i++) {
                newAppointmentData.serveInfo.push({
                  label: doc_info[i].name,
                  value: elem_info[i].name
                })
              }
              for (let i = 0; i < worker_info.length; i++) {
                newAppointmentData.providerList.push({
                  name: worker_info[i].name
                })
              }
              newAppointmentData.toStoreTime = formatTime(
                new Date(
                  +formData.service.new_appointment_info.spu[0].interval[0]
                    .new_appointment_start_date * 1000
                )
              ).slice(0, 16)
              newAppointmentData.toStoreTimeEnd = formatTime(
                new Date(
                  +formData.service.new_appointment_info.spu[0].interval[0]
                    .new_appointment_end_date * 1000
                )
              ).slice(11, 16)
              newAppointmentData.duration =
                +formData.service.new_appointment_info.spu[0]
                  .new_appointment_work_sec / 60
              newAppointmentData.goods_price = formData.service.goods_price
              newAppointmentData.endDate = newAppointmentData.toStoreTime.slice(
                0,
                10
              )
              newAppointmentData.providerTitle = new_appointment.manage_alias
              formData.newAppointmentData = newAppointmentData
            }
          }
          orders[i] = formData
        }
        if (param.scrollLoad) {
          orders = that.data.orderLists.concat(orders)
        }
        data['orderLists'] = orders
        data['pages'] = that.data.pages + 1
        data['noMore'] = res.is_more == 0 ? true : false
        if (typeof res.current_goods_type === 'object') {
          data['currentGoodsType'] = 9
        } else {
          data['currentGoodsType'] = res.current_goods_type
        }
        data['goodsTypeList'] = res.goods_type_list
        if (
          data['goodsTypeList'].indexOf(data['currentGoodsType'].toString()) < 0
        ) {
          data['goodsTypeList'].unshift(data['currentGoodsType'])
        }
        that._isAddCommunityOrder(function(res) {
          if (res.data != 0) {
            data['goodsTypeList'].push('21')
          }
          if (that.data.currentGoodsType == 21) {
            data['currentGoodsType'] = 21
          }
          if (!that.data.existGoodsType.length) {
            data.existGoodsType = []
            data.goodsTypeList.map(b => {
              that.goodsType.map(a => {
                if (b == a.type) {
                  data.existGoodsType.push(a)
                }
              })
            })
            data['existGoodsIndex'] = data.goodsTypeList.indexOf(
              data['currentGoodsType']
            )
          }
          that.setData(data)
        })
        if (param.firstLoad && data['goodsTypeList'].indexOf('6') >= 0) {
          that.getTostoreSetting()
        }
      }
    })
  }
  addLabelInput = e => {
    this.setData({ addLabelText: e.target.value })
  }
  goToUseStamps = event => {
    let couponId = event.currentTarget.dataset.couponid
    let appid = app.globalData.appId
    let franisee = ''
    let untimes = event.currentTarget.dataset.untimes
    franisee = '&franchisee=' + appid
    let url =
      '/exchangeCoupon/pages/numberOfStampsUsed/numberOfStampsUsed?detail=' +
      couponId +
      franisee
    this.setData({
      numberOfStampsUrl: url,
      hiddenmodalput: false,
      untimes: untimes
    })
  }
  confirm = (e) => {
    // if (e.keyCode !== 13) {
    //   return;
    // }
    if (+this.data.untimes < +this.data.addLabelText) {
      app.showModal({ content: '核销次数超过剩余次数' })
      this.setData({ hiddenmodalput: true, addLabelText: '' })
      return
    }
    let url = this.data.numberOfStampsUrl + '&Number=' + this.data.addLabelText
    this.setData({ hiddenmodalput: true, addLabelText: '' })
    app.turnToPage(url, false)
  }
  cancel = () => {
    this.setData({ hiddenmodalput: true, addLabelText: '' })
  }
  getTransportInfo = (orderId, i) => {
    let that = this,
      newdata = {}
    app.sendRequest({
      url: '/index.php?r=AppTransport/queryTransporterInfo',
      data: {
        order_id: orderId
      },
      success: function(res) {
        newdata['orderLists[' + i + '].transport'] = res.data
        newdata['marker[0].latitude'] = res.data.transporterLat
        newdata['marker[0].longitude'] = res.data.transporterLng
        that.setData(newdata)
      }
    })
  }
  mapDetail = e => {
    let dataset = e.currentTarget.dataset,
      marker = [
        {
          latitude: dataset.lat,
          longitude: dataset.lng,
          iconPath: '/images/transport.png',
          width: 75,
          height: 75
        }
      ]
    app.turnToPage(
      '/default/pages/mapDetail/mapDetail?eventParams=' + JSON.stringify(marker)
    )
  }
  clickOrderTab = e => {
    var dataset = e.target.dataset,
      index = dataset.index,
      data = {}
    data.currentTabIndex = index
    data['pages'] = 1
    data['orderLists'] = []
    data['noMore'] = false
    this.setData(data)
    this.getOrderList({ tabIndex: index })
  }
  clickMeanTab = pickerData => {
    let index = pickerData[0];
    let data = {}
    data.currentTabIndex = 0
    data.existGoodsIndex = index
    data['pages'] = 1
    data['orderLists'] = []
    data['noMore'] = false
    data.currentGoodsType = this.data.existGoodsType[index].type
    this.setData(data)
    this.hideGoodsPick()
    this.getOrderList({ tabIndex: 0 })
  }
  clickSubmenuTab = e => {
    let index = e.target.dataset.index
    let data = {}
    data.currentTabIndex = index
    data['pages'] = 1
    data['orderLists'] = []
    data['noMore'] = false
    this.setData(data)
    this.getOrderList({ tabIndex: index })
  }
  goToOrderDetail = e => {
    var dataset = e.currentTarget.dataset,
      orderId = dataset.id,
      type = dataset.type,
      franchiseeId = dataset.franchisee,
      queryStr =
        franchiseeId === app.getAppId() ? '' : '&franchisee=' + franchiseeId,
      router
    if (type === 'transfer') {
      router =
        '/eCommerce/pages/transferOrderDetail/transferOrderDetail?detail='
    } else if (type === 'tostore') {
      router = '/orderMeal/pages/tostoreOrderDetail/tostoreOrderDetail?detail='
    } else if (type === 'toDining') {
      router = '/eCommerce/pages/diningOrderDetail/diningOrderDetail?detail='
    } else if (type === 'eBusiness') {
      router = '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail='
    } else if (type === 'takeout') {
      router = '/orderMeal/pages/takeoutOrderDetail/takeoutOrderDetail?detail='
    } else if (type === 'rowNumber') {
      router =
        '/orderMeal/pages/rowNumberOrderDetail/rowNumberOrderDetail?detail='
    } else if (type === 'newAppoint') {
      router =
        '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?detail='
    } else if (type === 'ExchangeCoupon') {
      router =
        '/exchangeCoupon/pages/numberOfStampsOrderDetail/numberOfStampsOrderDetail?detail='
    } else if (type === 'hotel') {
      router =
        '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?aptType=2&detail='
    } else if (type === 'communityGroup') {
      router =
        '/promotion/pages/communityGroupOrderDetail/communityGroupOrderDetail?detail='
    } else {
      router =
        '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail='
    }
    app.turnToPage(router + orderId + queryStr)
  }
  cancelOrder = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      appId = app.getAppId(),
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this
    app.showModal({
      content: '你将要取消一笔付款订单，确认取消？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            app_id: appId,
            sub_shop_app_id: subShopId
          },
          success: function(res) {
            var index = that.data.currentTabIndex,
              data = {}
            data['pages'] = 1
            that.setData(data)
            that.getOrderList({ tabIndex: index })
          }
        })
      },
      cancel: function() {}
    })
  }
  orderDelete = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      appId = app.getAppId(),
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this
    app.showModal({
      content: '确定删除此订单吗？删除后不可再恢复哦',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirmColor: '#FF7100',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/HideOrder',
          data: {
            order_id: orderId,
            app_id: appId,
            sub_shop_app_id: subShopId
          },
          success: function(res) {
            var index = that.data.currentTabIndex,
              data = {}
            data['pages'] = 1
            that.setData(data)
            that.getOrderList({ tabIndex: index })
          }
        })
      }
    })
  }
  applyDrawback = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this,
      delivery = e.target.dataset.delivery
    app.showModal({
      content: delivery == 1 ? '确定要取消订单？' : '确定要申请退款？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/applyRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: subShopId
          },
          success: function(res) {
            var index = that.data.currentTabIndex,
              data = {}
            data['pages'] = 1
            that.setData(data)
            that.getOrderList({ tabIndex: index })
          }
        })
      }
    })
  }
  cancelRefund = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      appId = app.getAppId(),
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this,
      delivery = e.target.dataset.delivery
    app.showModal({
      content: '是否撤销取消订单申请？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelRefund',
          data: {
            app_id: appId,
            order_id: orderId
          },
          success: function(res) {
            var index = that.data.currentTabIndex,
              data = {}
            data['pages'] = 1
            that.setData(data)
            that.getOrderList({ tabIndex: index })
          }
        })
      }
    })
  }
  toCancelOrder = e => {
    let orderId = e.target.dataset.id
    let deliverType = e.target.dataset.deliver
    var dataset = e.currentTarget.dataset,
      franchiseeId = dataset.franchisee
    app.turnToPage(
      '/orderMeal/pages/cancelOrder/cancelOrder?orderId=' +
        orderId +
        '&deliverType=' +
        deliverType +
        '&franchisee=' +
        franchiseeId
    )
  }
  checkLogistics = e => {
    let orderLists = this.data.orderLists
    let index = e.target.dataset.index
    let orderId = orderLists[index].order_id
    let usePickType = orderLists[index].ecommerce_info.dispatch_use_pick_up_type
    let franchiseeId = e.target.dataset.franchisee
    if (usePickType == 2) {
      let intraCityData = orderLists[index].ecommerce_info.intra_city_data
      let type = (intraCityData && intraCityData.deliver_type) || ''
      let arriveTime =
        (intraCityData && intraCityData.intra_city_appointment_arrive_time) ||
        ''
      app.turnToPage(
        '/eCommerce/pages/sameJourneyLogistic/sameJourneyLogistic?orderId=' +
          orderId +
          '&type=' +
          type +
          '&arriveTime=' +
          arriveTime +
          '&franchiseeId=' +
          franchiseeId
      )
    } else {
      app.turnToPage(
        '/eCommerce/pages/logisticsPage/logisticsPage?detail=' +
          orderId +
          '&franchiseeId=' +
          franchiseeId
      )
    }
  }
  sureReceipt = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this,
      content =
        this.data.currentGoodsType == '1'
          ? '确认已消费?'
          : '确认收货代表您已经拿到货物，确认后将无法撤销！建议与商家联系后再操作'
    app.showModal({
      content: content,
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: subShopId
          },
          success: function(res) {
            var index = that.data.currentTabIndex,
              data = {},
              addTime = Date.now()
            data['pages'] = 1
            that.setData(data)
            if (that.data.currentGoodsType == 0) {
              app.turnToPage(
                '/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=transation&orderId=' +
                  orderId +
                  '&franchiseeId=' +
                  subShopId
              )
            } else {
              that.getOrderList({ tabIndex: index })
            }
            app.sendRequest({
              hideLoading: true,
              url: '/index.php?r=appShop/getIntegralLog',
              data: { add_time: addTime },
              success: function(res) {
                if (res.status == 0) {
                  res.data &&
                    that.setData({
                      rewardPointObj: {
                        showModal: true,
                        count: res.data,
                        callback: ''
                      }
                    })
                }
              }
            })
          }
        })
      }
    })
  }
  makeComment = e => {
    var orderId = e.target.dataset.id,
      franchiseeId = e.target.dataset.franchisee,
      queryStr =
        franchiseeId === app.getAppId() ? '' : '&franchisee=' + franchiseeId
    app.turnToPage(
      '/eCommerce/pages/makeComment/makeComment?detail=' + orderId + queryStr
    )
  }
  takeoutMakeComment = e => {
    var orderId = e.target.dataset.id,
      franchiseeId = e.target.dataset.franchisee,
      queryStr =
        franchiseeId === app.getAppId() ? '' : '&franchisee=' + franchiseeId
    app.turnToPage(
      '/orderMeal/pages/takeoutMakeComment/takeoutMakeComment?detail=' +
        orderId +
        queryStr
    )
  }
  scrollToListBottom = () => {
    var currentTabIndex = this.data.currentTabIndex
    if (this.data.noMore) {
      return
    }
    this.getOrderList({
      tabIndex: currentTabIndex,
      scrollLoad: true
    })
  }
  getTostoreSetting = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
      success: function(res) {
        if (res.status == 0) {
          _this.setData({
            toStoreSetting: res.data
          })
        }
      }
    })
  }
  getWriteOffCodeBox = event => {
    let _this = this
    let orderId = event.target.dataset.id
    let franchiseeId = event.target.dataset.franchisee
    app.sendRequest({
      url: '/index.php?r=AppShop/GetOrderVerifyCode',
      data: {
        sub_shop_app_id: franchiseeId,
        order_id: orderId
      },
      success: _this.setVerificationCodeData
    })
  }
  setVerificationCodeData = res => {
    let _this = this
    _this.setData({
      codeImgUrl: res.data.qrcode_url,
      codeNum: res.data.code,
      codeStatus: res.data.status,
      showWriteOffCodeBox: true
    })
    _this.connectSocket()
  }
  connectSocket = () => {
    var _this = this
    app.connectSocket({
      url: 'wss://ceshi.zhichiwangluo.com',
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    app.onSocketOpen(function(res) {
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_order_verify',
        session_key: app.globalData.sessionKey
      }
      app.sendSocketMessage({
        data: JSON.stringify(data)
      })
      _this.verifiTimeInterval = setInterval(function() {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: app.globalData.sessionKey
        }
        app.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    app.onSocketMessage(function(res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_order_verify' && msg.status == 0) {
          _this.setData({
            codeStatus: 1
          })
          clearInterval(_this.verifiTimeInterval)
          app.closeSocket()
        }
      }
    })
  }
  hideWriteOffCodeBox = () => {
    var _this = this
    this.setData({
      showWriteOffCodeBox: false
    })
    clearInterval(_this.verifiTimeInterval)
    app.closeSocket()
  }
  onemore = () => {}
  toPayOrder = () => {}
  payOrder = event => {
    var that = this,
      orderId,
      price = event.target.dataset.price
    var franchiseeId = event.target.dataset.franchisee
    orderId = event.target.dataset.id
    if (price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function(res) {
          setTimeout(function() {
            app.showToast({
              title: '支付成功',
              icon: 'success'
            })
          })
          setTimeout(function() {
            var index = that.data.currentTabIndex,
              data = {}
            data['pages'] = 1
            that.setData(data)
            that.getOrderList({ tabIndex: index })
          }, 1000)
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId,
    //     sub_shop_app_id: franchiseeId == app.getAppId() ? '' : franchiseeId
    //   },
    //   success: function(res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.goodsType = that.data.currentGoodsType
    //     param.success = function() {
    //       setTimeout(function() {
    //         var index = that.data.currentTabIndex,
    //           data = {}
    //         data['pages'] = 1
    //         that.setData(data)
    //         that.getOrderList({ tabIndex: index })
    //       }, 1500)
    //     }
    //     app.wxPay(param)
    //   }
    // })
    
    // TODO:支付成功回调要考虑一下怎么处理
    app.goPay({
      orderId: orderId,
      franchisee: franchiseeId == app.getAppId() ? '' : franchiseeId
    });
  }
  getTakeOutInfo = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getTakeOutInfo',
      success: function(res) {
        that.setData({
          takeoutInfo: res.data || ''
        })
      }
    })
  }
  SectionToChinese = section => {
    let strIns = '',
      chnStr = ''
    let unitPos = 0
    let zero = true
    let chnNumChar = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九'
    ]
    let chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
    let chnUnitChar = ['', '十', '百', '千']
    while (section > 0) {
      let v = section % 10
      if (v === 0) {
        if (!zero) {
          zero = true
          chnStr = chnNumChar[v] + chnStr
        }
      } else {
        zero = false
        strIns = chnNumChar[v]
        strIns += chnUnitChar[unitPos]
        chnStr = strIns + chnStr
      }
      unitPos++
      section = Math.floor(section / 10)
    }
    return chnStr
  }
  NumberToChinese = num => {
    let unitPos = 0
    let strIns = '',
      chnStr = ''
    let needZero = false
    let chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
    let chnNumChar = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九'
    ]
    if (num === 0) {
      return chnNumChar[0]
    }
    while (num > 0) {
      let section = num % 10000
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr
      }
      strIns = this.SectionToChinese(section)
      strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0]
      chnStr = strIns + chnStr
      needZero = section < 1000 && section > 0
      num = Math.floor(num / 10000)
      unitPos++
    }
    return chnStr
  }
  receiveDrawback = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      appId = app.getAppId(),
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this
    app.showModal({
      content: '确定已收到退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: subShopId
          },
          success: function(res) {
            var index = that.data.currentTabIndex,
              data = {}
            data['pages'] = 1
            that.setData(data)
            that.getOrderList({ tabIndex: index })
          }
        })
      }
    })
  }
  SectionToChinese = section => {
    let strIns = '',
      chnStr = ''
    let unitPos = 0
    let zero = true
    let chnNumChar = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九'
    ]
    let chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
    let chnUnitChar = ['', '十', '百', '千']
    while (section > 0) {
      let v = section % 10
      if (v === 0) {
        if (!zero) {
          zero = true
          chnStr = chnNumChar[v] + chnStr
        }
      } else {
        zero = false
        strIns = chnNumChar[v]
        strIns += chnUnitChar[unitPos]
        chnStr = strIns + chnStr
      }
      unitPos++
      section = Math.floor(section / 10)
    }
    return chnStr
  }
  NumberToChinese = num => {
    let unitPos = 0
    let strIns = '',
      chnStr = ''
    let needZero = false
    let chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
    let chnNumChar = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九'
    ]
    if (num === 0) {
      return chnNumChar[0]
    }
    while (num > 0) {
      let section = num % 10000
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr
      }
      strIns = this.SectionToChinese(section)
      strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0]
      chnStr = strIns + chnStr
      needZero = section < 1000 && section > 0
      num = Math.floor(num / 10000)
      unitPos++
    }
    return chnStr
  }
  toSeeQrcode = event => {
    let orderId = event.target.dataset.id,
      franchiseeId = event.target.dataset.franchisee,
      codeEndDate = event.target.dataset.enddate,
      pagePath =
        '/newAppointment/pages/newAppointmentQrcode/newAppointmentQrcode?orderId=' +
        orderId +
        '&franchiseeId=' +
        franchiseeId +
        '&codeEndDate=' +
        codeEndDate
    app.turnToPage(pagePath)
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config,
        hasRecommendConfig: res.recommend_config ? true : false
      })
    })
  }
  _isAddCommunityOrder = callback => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppDistributionExt/CountDistributionOrderByBuyerId',
      hideLoading: true,
      success: function(res) {
        callback && callback(res)
      }
    })
  }
  showGoodsPick = () => {
    let _this = this
    this.setData({
      showGoodsPickBox: !_this.data.showGoodsPickBox
    })
  }
  selectGoodsPick = e => {
    this.setData({
      selectGoodsPickIndex: e.currentTarget.dataset.type,
      pages: 1,
      showGoodsPickBox: false
    })
    this.getOrderList({
      tabIndex: this.data.currentTabIndex,
      firstLoad: true
    })
  }
  searchOrderId = e => {
    if (e.keyCode !== 13) {
      return;
    }
    this.setData({
      searchOrderId: e.target.value,
      pages: 1
    })
    this.getOrderList({
      tabIndex: this.data.currentTabIndex,
      firstLoad: true
    })
  }
  stopPropagation = () => {}
  hideGoodsPick = () => {
    this.setData({
      showGoodsPickBox: false
    })
  }
  inputOrderId = e => {
    this.setData({
      searchOrderId: e.currentTarget.value
    })
  }

  privateStopNoop(e) {
    e.stopPropagation()
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      franchiseeIdInfo,
      existGoodsIndex,
      existGoodsType,
      selectGoodsPickIndex,
      currentTabIndex,
      currentGoodsType,
      orderLists,
      goodsOrderStatusName,
      noMore,
      takeoutInfo,
      transportStatus,
      marker,
      goodsNum,
      toStoreSetting,
      codeImgUrl,
      codeStatus,
      codeNum,
      showWriteOffCodeBox,
      showGoodsPickBox,
      hiddenmodalput,
      addLabelText,
    } = this.state


    // 处理成UI组件需要的数据格式
    let pickerData = [];
    if (existGoodsType.length) {
      existGoodsType.forEach((item, index) => {
        pickerData.push({
          label: item.name,
          value: index,
        });
      });
    }
  
    return (
      <div className="official-page my-order">
        <TopNav title="订单列表"/>
        <div className="app">
          <div className="myOrder-wrap page" id="myOrder">
            <div className="order-list-header">
              <Picker cols={1}
                      data={pickerData}
                      value={[existGoodsIndex]}
                      onChange={this.clickMeanTab}
              >
                <div className="picker-inner">
                  <span className="exits-name">
                    {!!pickerData.length && pickerData[existGoodsIndex] && pickerData[existGoodsIndex].label}
                  </span>
                  <span className="ico-moon icon-downarrow"></span>
                </div>
              </Picker>
              <div className="order-list-search">
                <span className="ico-moon icon-search"></span>
                <input
                  onChange={this.inputOrderId}
                  type="text"
                  onKeyDown={this.searchOrderId}
                  placeholder="请输入订单号"
                />
              </div>
            </div>
            <div className="myOrder-tab-list">
              {currentGoodsType == 0 && (
                <React.Fragment>
                  {selectGoodsPickIndex != 4 ? (
                    <div
                      className="tab-list-submenu goods-list-submenu"
                      onClick={this.clickSubmenuTab}
                    >
                      <div
                        className={currentTabIndex == 0 ? 'active' : ''}
                        data-index="0"
                      >
                        <span className="bottom-line"></span>全部
                      </div>
                      <div
                        className={currentTabIndex == 1 ? 'active' : ''}
                        data-index="1"
                      >
                        <span className="bottom-line"></span>待付款
                      </div>
                      <div
                        className={currentTabIndex == 5 ? 'active' : ''}
                        data-index="5"
                      >
                        <span className="bottom-line"></span>待接单
                      </div>
                      <div
                        className={currentTabIndex == 2 ? 'active' : ''}
                        data-index="2"
                      >
                        <span className="bottom-line"></span>待发货
                      </div>
                      <div
                        className={currentTabIndex == 3 ? 'active' : ''}
                        data-index="3"
                      >
                        <span className="bottom-line"></span>待收货
                      </div>
                      <div
                        className={currentTabIndex == 4 ? 'active' : ''}
                        data-index="4"
                      >
                        <span className="bottom-line"></span>待评价
                      </div>
                      <div
                        className={currentTabIndex == 6 ? 'active' : ''}
                        data-index="6"
                      >
                        <span className="bottom-line"></span>已完成
                      </div>
                      <div
                        className={currentTabIndex == 7 ? 'active' : ''}
                        data-index="7"
                      >
                        <span className="bottom-line"></span>已关闭
                      </div>
                      <div
                        onClick={this.showGoodsPick}
                        className="filter-goods-pick"
                      >
                        {selectGoodsPickIndex == '0'
                          ? '取货'
                          : selectGoodsPickIndex == '1'
                          ? '快递'
                          : selectGoodsPickIndex == '2'
                          ? '同城'
                          : selectGoodsPickIndex == '3'
                          ? '自提'
                          : '堂食'}
                        <span className="trangel"></span>
                      </div>
                    </div>
                  ) : (
                    selectGoodsPickIndex == 4 && (
                      <div
                        className="tab-list-submenu goods-list-submenu"
                        onClick={this.clickSubmenuTab}
                      >
                        <div
                          className={currentTabIndex == 0 ? 'active' : ''}
                          data-index="0"
                        >
                          <span className="bottom-line"></span>全部
                        </div>
                        <div
                          className={currentTabIndex == 5 ? 'active' : ''}
                          data-index="5"
                        >
                          <span className="bottom-line"></span>待商家接单
                        </div>
                        <div
                          className={currentTabIndex == 8 ? 'active' : ''}
                          data-index="8"
                        >
                          <span className="bottom-line"></span>已下单
                        </div>
                        <div
                          className={currentTabIndex == 1 ? 'active' : ''}
                          data-index="1"
                        >
                          <span className="bottom-line"></span>待付款
                        </div>
                        <div
                          className={currentTabIndex == 4 ? 'active' : ''}
                          data-index="4"
                        >
                          <span className="bottom-line"></span>待评价
                        </div>
                        <div
                          className={currentTabIndex == 6 ? 'active' : ''}
                          data-index="6"
                        >
                          <span className="bottom-line"></span>已完成
                        </div>
                        <div
                          className={currentTabIndex == 7 ? 'active' : ''}
                          data-index="7"
                        >
                          <span className="bottom-line"></span>已关闭
                        </div>
                        <div
                          onClick={this.showGoodsPick}
                          className="filter-goods-pick"
                        >
                          {selectGoodsPickIndex == '0'
                            ? '取货'
                            : selectGoodsPickIndex == '1'
                            ? '快递'
                            : selectGoodsPickIndex == '2'
                            ? '同城'
                            : selectGoodsPickIndex == '3'
                            ? '自提'
                            : '堂食'}
                          <span className="trangel"></span>
                        </div>
                      </div>
                    )
                  )}
                </React.Fragment>
              )}
              {currentGoodsType == 1 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>待确认
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>待消费
                  </div>
                  <div
                    className={currentTabIndex == 4 ? 'active' : ''}
                    data-index="4"
                  >
                    <span className="bottom-line"></span>待评价
                  </div>
                </div>
              )}
              {currentGoodsType == 3 && (
                <div
                  className="tab-list-submenu"
                  data-goods-type="3"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>待确认
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>商家已确认
                  </div>
                  <div
                    className={currentTabIndex == 4 ? 'active' : ''}
                    data-index="4"
                  >
                    <span className="bottom-line"></span>待评价
                  </div>
                  <div
                    className={currentTabIndex == 5 ? 'active' : ''}
                    data-index="5"
                  >
                    <span className="bottom-line"></span>退款
                  </div>
                  <div
                    className={currentTabIndex == 6 ? 'active' : ''}
                    data-index="6"
                  >
                    <span className="bottom-line"></span>已关闭
                  </div>
                </div>
              )}
              {currentGoodsType == 5 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待支付
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>已完成
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>已关闭
                  </div>
                </div>
              )}
              {currentGoodsType == 2 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>已完成
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>已关闭
                  </div>
                </div>
              )}
              {currentGoodsType == 6 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待使用
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>已使用
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>已失效
                  </div>
                </div>
              )}
              {currentGoodsType == 10 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>待确认
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>待消费
                  </div>
                  <div
                    className={currentTabIndex == 4 ? 'active' : ''}
                    data-index="4"
                  >
                    <span className="bottom-line"></span>待评价
                  </div>
                </div>
              )}
              {currentGoodsType == 8 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>已付款
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>已关闭
                  </div>
                </div>
              )}
              {currentGoodsType == 9 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>已付款
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>已关闭
                  </div>
                </div>
              )}
              {currentGoodsType == 21 && (
                <div
                  className="tab-list-submenu"
                  onClick={this.clickSubmenuTab}
                >
                  <div
                    className={currentTabIndex == 0 ? 'active' : ''}
                    data-index="0"
                  >
                    <span className="bottom-line"></span>全部
                  </div>
                  <div
                    className={currentTabIndex == 1 ? 'active' : ''}
                    data-index="1"
                  >
                    <span className="bottom-line"></span>待付款
                  </div>
                  <div
                    className={currentTabIndex == 2 ? 'active' : ''}
                    data-index="2"
                  >
                    <span className="bottom-line"></span>待发货
                  </div>
                  <div
                    className={currentTabIndex == 3 ? 'active' : ''}
                    data-index="3"
                  >
                    <span className="bottom-line"></span>配送中
                  </div>
                  <div
                    className={currentTabIndex == 4 ? 'active' : ''}
                    data-index="4"
                  >
                    <span className="bottom-line"></span>待提货
                  </div>
                  <div
                    className={currentTabIndex == 5 ? 'active' : ''}
                    data-index="5"
                  >
                    <span className="bottom-line"></span>待评价
                  </div>
                </div>
              )}
            </div>
            <div className="myOrder-content-body">
              {
                currentGoodsType == 0 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          key={item.order_id || index}
                          className="myOrder-list-wrap"
                          onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                          data-franchisee={item.app_id}
                          data-id={item.order_id}
                          data-type={
                            item.pick_up_type == 4 ? 'toDining' : 'eBusiness'
                          }
                          style={convertLineStyleData(
                            item.ecommerce_info && item.ecommerce_info.dispatch_use_pick_up_type == 4
                              ? 'padding: 0 24rpx;'
                              : 'padding:0;'
                          )}
                        >
                          {item.ecommerce_info && item.ecommerce_info.dispatch_use_pick_up_type != 4 ? (
                            <React.Fragment>
                              <div className="goods-order-header">
                                <div style={convertLineStyleData('padding-bottom:2rpx;')}>
                                  {item.is_pay_on_delivery == 1 && (
                                    <span className="cash-delivery">
                                      货到付款
                                    </span>
                                  )}
                                  {item.pick_up_type == 1 ? (
                                    <span className="goods-order-time">
                                      {item.add_time}
                                    </span>
                                  ) : item.pick_up_type == 2 ? (
                                    <span className="goods-order-time">
                                      {'编号 : ' +
                                        item.ecommerce_info.intra_city_data
                                          .serial_number}
                                    </span>
                                  ) : (
                                    item.pick_up_type == 3 && (
                                      <span className="goods-order-time">
                                        {'流水号 : ' +
                                          (item.ecommerce_info.ec_tostore_data
                                            .formatted_queue_num || '')}
                                      </span>
                                    )
                                  )}
                                  <span className="pull-right myOrder-order-status">
                                    {item.is_pay_on_delivery == 1 &&
                                    item.status == 4
                                      ? '审核中'
                                      : item.pick_up_type == 3 && item.status == 1
                                      ? '待接单'
                                      : goodsOrderStatusName[item.status]}
                                  </span>
                                </div>
                              </div>
                              {item.sub_shop_info && item.sub_shop_info.name && (
                                <div className="myOrder-franchisee-name">
                                  {item.sub_shop_info.name}
                                </div>
                              )}
                              {item.goods_info.map((goods, index) => {
                                return (
                                  <div className="goods-order-content" key={goods.id || index}>
                                    {!!+goods.use_integral && (
                                      <div className="myOrder-goods-tips">
                                        <div className="myOrder-goods-tips-top">
                                          积
                                        </div>
                                        <div className="myOrder-goods-tips-left"></div>
                                        <div className="myOrder-goods-tips-right"></div>
                                      </div>
                                    )}
                                    <img
                                      className="cover"
                                      src={goods.cover}
                                    />
                                    <div className="goods-order-detail">
                                      <div className="title">
                                        {!!+goods.is_benefit_goods && (
                                          <span className="goods-gift">赠品</span>
                                        )}
                                        {!!+goods.is_vip_goods && (
                                          <span className="goods-gift">
                                            会员价
                                          </span>
                                        )}
                                        {goods.goods_name}
                                      </div>
                                      <div className="pull-right count">
                                        {'×' + goods.num}
                                      </div>
                                      {goods.use_integral == 0 ? (
                                        <React.Fragment>
                                          <span className="myOrder-goods-price">
                                            {'¥' + goods.price}
                                          </span>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          {(goods.price != '0.00' ||
                                            !goods.use_integral ||
                                            goods.use_integral == 0) && (
                                            <span className="myOrder-goods-price">
                                              {'¥' + goods.price}
                                            </span>
                                          )}
                                          {goods.use_integral &&
                                            goods.use_integral != 0 &&
                                            goods.price != '0.00' && (
                                              <span>+</span>
                                            )}
                                          {goods.use_integral && (
                                            <span>
                                              {goods.use_integral + '积分'}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </div>
                                  </div>
                                )
                              })}
                              {item.goods_info[0].is_presell == 1 ? (
                                <div className="presell-order-bottom">
                                  <span style={convertLineStyleData('margin-right:20rpx;')}>
                                    {'定金已支付：¥ ' + item.total_bargain}
                                  </span>
                                  <span>
                                    {'尾款已支付：¥ ' + item.total_final_payment}
                                  </span>
                                </div>
                              ) : (
                                <div className="goods-order-bottom">
                                  <span className="myOrder-list-count">
                                    {'共' + item.goods_num + '件商品'}
                                  </span>
                                  {item.is_integral != '1' && (
                                    <span>
                                      合计：
                                      <span className="total-price">
                                        {'¥' + item.original_price}
                                      </span>
                                    </span>
                                  )}
                                  {item.is_integral == '1' && (
                                    <span>
                                      合计：
                                      {((item.original_price != 0 &&
                                        item.original_price != '0.00') ||
                                        !item.total_integral ||
                                        item.total_integral == 0) && (
                                        <span className="myOrder-pay-price">
                                          {'¥' + item.original_price}
                                        </span>
                                      )}
                                      {item.total_integral &&
                                        item.total_integral != 0 &&
                                        item.original_price != 0 &&
                                        item.original_price != '0.00' && (
                                          <span className="myOrder-pay-price">
                                            +
                                          </span>
                                        )}
                                      {item.total_integral && (
                                        <span className="myOrder-pay-price">
                                          {item.total_integral + '积分'}
                                        </span>
                                      )}
                                    </span>
                                  )}
                                </div>
                              )}
                              {item.status == 0 ? (
                                <div className="goods-btn-box">
                                  <span
                                    className="btn myOrder-cancel-order"
                                    onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                    data-franchisee={item.app_id}
                                    data-id={item.order_id}
                                  >
                                    取消订单
                                  </span>
                                  <span
                                    className="btn btn-orange myOrder-pay-directly"
                                    onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                    data-franchisee={item.app_id}
                                    data-id={item.order_id}
                                    data-type="eBusiness"
                                  >
                                    支付
                                  </span>
                                </div>
                              ) : item.status == 1 ? (
                                <div className="goods-btn-box">
                                  {item.is_pay_on_delivery == 1 && (
                                    <span
                                      className="btn myOrder-cancel-order"
                                      data-delivery={item.is_pay_on_delivery}
                                      onClick={(e) => {this.applyDrawback(e);e.stopPropagation()}}
                                      data-franchisee={item.app_id}
                                      data-id={item.order_id}
                                    >
                                      取消订单
                                    </span>
                                  )}
                                </div>
                              ) : item.status == 2 ? (
                                <div className="goods-btn-box">
                                  {item.is_pay_on_delivery == 1 && (
                                    <span
                                      className="btn myOrder-cancel-order"
                                      data-delivery={item.is_pay_on_delivery}
                                      onClick={(e) => {this.applyDrawback(e);e.stopPropagation()}}
                                      data-franchisee={item.app_id}
                                      data-id={item.order_id}
                                    >
                                      取消订单
                                    </span>
                                  )}
                                  {item.pick_up_type != 3 && (
                                    <span
                                      className="btn myOrder-check-logistics"
                                      onClick={this.checkLogistics}
                                      data-index={index}
                                      data-franchisee={item.app_id}
                                    >
                                      配送信息
                                    </span>
                                  )}
                                  <span
                                    className="btn btn-orange myOrder-sure-receipt"
                                    onClick={(e) => {this.sureReceipt(e);e.stopPropagation()}}
                                    data-franchisee={item.app_id}
                                    data-id={item.order_id}
                                  >
                                    确认收货
                                  </span>
                                </div>
                              ) : (
                                item.status == 3 && (
                                  <div className="goods-btn-box">
                                    <span
                                      className="btn btn-orange myOrder-make-comment"
                                      onClick={(e) => {this.makeComment(e);e.stopPropagation()}}
                                      data-franchisee={item.app_id}
                                      data-id={item.order_id}
                                    >
                                      去评价
                                    </span>
                                  </div>
                                )
                              )}
                            </React.Fragment>
                          ) : (
                            item.ecommerce_info && item.ecommerce_info.dispatch_use_pick_up_type ==
                              4 && (
                              <React.Fragment>
                                <div className="dialog-block-item myOrder-tostore-top">
                                  <span className="dialog-block-time">
                                    {'下单时间: ' + item.add_time}
                                  </span>
                                  <span className="pull-right tostore-see-detail">
                                    查看详情
                                  </span>
                                </div>
                                {item.sub_shop_info && item.sub_shop_info.name && (
                                  <div className="myOrder-franchisee-name">
                                    {item.sub_shop_info.name}
                                  </div>
                                )}
                                <div className="myOrder-goods-list">
                                  {item.goods_info.map((goods, index) => {
                                    return (
                                      <div
                                        className="goods-order-content"
                                        style={convertLineStyleData('display:flex;')}
                                        key={goods.id || index}
                                      >
                                        {!!+goods.use_integral && (
                                          <div className="myOrder-goods-tips">
                                            <div className="myOrder-goods-tips-top">
                                              积
                                            </div>
                                            <div className="myOrder-goods-tips-left"></div>
                                            <div className="myOrder-goods-tips-right"></div>
                                          </div>
                                        )}
                                        <img
                                          className="cover"
                                          src={goods.cover}
                                        />
                                        <div className="goods-order-detail">
                                          <div className="title">
                                            {!!+goods.is_benefit_goods && (
                                              <span className="goods-gift">
                                                赠品
                                              </span>
                                            )}
                                            {!!+goods.is_vip_goods && (
                                              <span className="goods-gift">
                                                会员价
                                              </span>
                                            )}
                                            {goods.goods_name}
                                          </div>
                                          <div className="pull-right count">
                                            {'×' + goods.num}
                                          </div>
                                          {goods.use_integral == 0 ? (
                                            <React.Fragment>
                                              <span className="myOrder-goods-price">
                                                {'¥' + goods.price}
                                              </span>
                                            </React.Fragment>
                                          ) : (
                                            <React.Fragment>
                                              {(goods.price != '0.00' ||
                                                !goods.use_integral ||
                                                goods.use_integral == 0) && (
                                                <span className="myOrder-goods-price">
                                                  {'¥' + goods.price}
                                                </span>
                                              )}
                                              {goods.use_integral &&
                                                goods.use_integral != 0 &&
                                                goods.price != '0.00' && (
                                                  <span>+</span>
                                                )}
                                              {goods.use_integral && (
                                                <span>
                                                  {goods.use_integral + '积分'}
                                                </span>
                                              )}
                                            </React.Fragment>
                                          )}
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                                <div className="myOrder-list-bottom">
                                  <div>
                                    {item.tostore_data.formatted_queue_num && (
                                      <label className="pull-left">
                                        取餐号：
                                        <span>
                                          {item.tostore_data.formatted_queue_num}
                                        </span>
                                      </label>
                                    )}
                                    <label>
                                      <span className="myOrder-list-count">
                                        {'共' + item.goods_num + '件'}
                                      </span>
                                      {item.is_integral != '1' ? (
                                        <React.Fragment>
                                          <span>
                                            {'¥ ' + item.original_price}
                                          </span>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          {((item.original_price != '0.00' &&
                                            item.original_price != 0) ||
                                            !item.total_integral ||
                                            item.total_integral == 0) && (
                                            <span>
                                              {'¥' + item.original_price}
                                            </span>
                                          )}
                                          {item.original_price != '0.00' &&
                                            item.original_price != 0 &&
                                            item.total_integral &&
                                            item.total_integral != 0 && (
                                              <span>+</span>
                                            )}
                                          {item.total_integral &&
                                            item.total_integral != 0 && (
                                              <span>
                                                {item.total_integral + '积分'}
                                              </span>
                                            )}
                                        </React.Fragment>
                                      )}
                                      {item.status == 0 ? (
                                        <span className="tostore-order-status">
                                          待付款
                                        </span>
                                      ) : item.status == 1 ? (
                                        <span className="tostore-order-status">
                                          等待商家确认
                                        </span>
                                      ) : item.status == 2 ? (
                                        <span className="tostore-order-status">
                                          商家已确认
                                        </span>
                                      ) : item.status == 3 ? (
                                        <span className="tostore-order-status">
                                          待评价
                                        </span>
                                      ) : item.status == 4 ? (
                                        <span className="tostore-order-status">
                                          退款审核中
                                        </span>
                                      ) : item.status == 5 ? (
                                        <span className="tostore-order-status">
                                          正在退款中
                                        </span>
                                      ) : item.status == 6 ? (
                                        <span className="tostore-order-status">
                                          已完成
                                        </span>
                                      ) : item.status == 7 ? (
                                        <span className="tostore-order-status">
                                          已关闭
                                        </span>
                                      ) : item.status == 8 ? (
                                        <span className="tostore-order-status">
                                          待接单
                                        </span>
                                      ) : item.status == 16 ? (
                                        <span className="tostore-order-status">
                                          待接单
                                        </span>
                                      ) : (
                                        item.status == 17 && (
                                          <span className="tostore-order-status">
                                            已下单
                                          </span>
                                        )
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </React.Fragment>
                            )
                          )}
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 1 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-appointment myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div className="myOrder-list-wrap" key={item.order_id || index}>
                          <div className="dialog-block-item">
                            <span className="dialog-block-time">
                              {item.add_time}
                            </span>
                            {item.status == 0 ? (
                              <span className="pull-right myOrder-order-status">
                                待付款
                              </span>
                            ) : item.status == 1 ? (
                              <span className="pull-right myOrder-order-status">
                                等待商家确认
                              </span>
                            ) : item.status == 2 ? (
                              <span className="pull-right myOrder-order-status">
                                待消费
                              </span>
                            ) : item.status == 3 ? (
                              <span className="pull-right myOrder-order-status">
                                待评价
                              </span>
                            ) : item.status == 4 ? (
                              <span className="pull-right myOrder-order-status">
                                退款审核中
                              </span>
                            ) : item.status == 5 ? (
                              <span className="pull-right myOrder-order-status">
                                正在退款中
                              </span>
                            ) : item.status == 6 ? (
                              <span className="pull-right myOrder-order-status">
                                已消费
                              </span>
                            ) : (
                              item.status == 7 && (
                                <span className="pull-right myOrder-order-status">
                                  已关闭
                                </span>
                              )
                            )}
                          </div>
                          {item.sub_shop_info && item.sub_shop_info.name && (
                            <div className="myOrder-franchisee-name">
                              {item.sub_shop_info.name}
                            </div>
                          )}
                          <div
                            className="myOrder-goods-list"
                            onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                            data-franchisee={item.app_id}
                            data-id={item.order_id}
                          >
                            {Array.isArray(item.goods_info) && item.goods_info.map((goods, index) => {
                              return (
                                <div key={goods.id || index}>
                                  <div className="dialog-block-item">
                                    {goods.use_integral && (
                                      <div className="myOrder-goods-tips">
                                        <div className="myOrder-goods-tips-top">
                                          积
                                        </div>
                                        <div className="myOrder-goods-tips-left"></div>
                                        <div className="myOrder-goods-tips-right"></div>
                                      </div>
                                    )}
                                    <img
                                      className="myOrder-goods-cover"
                                      src={goods.cover}
                                    />
                                    <div className="myOrder-goods-title">
                                      {!!+goods.is_vip_goods && (
                                        <span className="goods-gift">会员价</span>
                                      )}
                                      {goods.goods_name}
                                    </div>
                                    <div className="myOrder-goods-right">
                                      <div>
                                        {goods.use_integral == 0 ? (
                                          <React.Fragment>
                                            <span className="myOrder-goods-price">
                                              {'¥' + goods.price}
                                            </span>
                                          </React.Fragment>
                                        ) : (
                                          <React.Fragment>
                                            {(goods.price != '0.00' ||
                                              !goods.use_integral ||
                                              goods.use_integral == 0) && (
                                              <span className="myOrder-goods-price">
                                                {'¥' + goods.price}
                                              </span>
                                            )}
                                            {goods.use_integral &&
                                              goods.use_integral != 0 &&
                                              goods.price != '0.00' && (
                                                <span>+</span>
                                              )}
                                            {goods.use_integral && (
                                              <span>
                                                {goods.use_integral + '积分'}
                                              </span>
                                            )}
                                          </React.Fragment>
                                        )}
                                      </div>
                                      <div>
                                        ×
                                        <span className="myOrder-goods-count">
                                          {goods.num}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div className="dialog-block-item myOrder-total-item">
                            {item.is_integral != '1' && (
                              <span>
                                合计：
                                <span className="myOrder-pay-price">
                                  {'¥' + item.total_price}
                                </span>
                              </span>
                            )}
                            {item.is_integral == '1' && (
                              <span>
                                合计：
                                {((item.original_price != '0.00' &&
                                  item.original_price != 0) ||
                                  !item.total_integral ||
                                  item.total_integral == 0) && (
                                  <span className="myOrder-pay-price">
                                    {'¥' + item.original_price}
                                  </span>
                                )}
                                {item.total_integral &&
                                  item.total_integral != 0 &&
                                  item.original_price != 0 &&
                                  item.original_price != '0.00' && (
                                    <span className="myOrder-pay-price">+</span>
                                  )}
                                {item.total_integral && (
                                  <span className="myOrder-pay-price">
                                    {item.total_integral + '积分'}
                                  </span>
                                )}
                              </span>
                            )}
                            {/*  <text>合计：<text class="myOrder-pay-price" wx:if="{{item.original_price != '0.00'}}">¥{{ item.original_price }}</text><text wx:if="{{item.total_integral && item.total_integral != 0 && item.original_price != '0.00'}}" class="myOrder-pay-price">+</text><text wx:if="{{item.total_integral}}" class="myOrder-pay-price">{{item.total_integral}}积分</text></text>  */}
                          </div>
                          {item.status == 0 ? (
                            <div className="myOrder-list-bottom">
                              <span
                                className="btn myOrder-cancel-order"
                                onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                取消订单
                              </span>
                              <span
                                className="btn btn-orange myOrder-pay-directly"
                                onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                支付
                              </span>
                            </div>
                          ) : item.status == 1 ? (
                            <div className="myOrder-list-bottom">
                              <span
                                className="btn myOrder-verification-code"
                                onClick={(e) => {this.getWriteOffCodeBox(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                核销码
                              </span>
                              {!item.timeDiff && (
                                <span
                                  className="btn myOrder-apply-drawback"
                                  onClick={(e) => {this.applyDrawback(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  申请退款
                                </span>
                              )}
                            </div>
                          ) : item.status == 2 ? (
                            <div className="myOrder-list-bottom">
                              {!item.timeDiff && (
                                <span
                                  className="btn myOrder-apply-drawback"
                                  onClick={(e) => {this.applyDrawback(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  申请退款
                                </span>
                              )}
                              <span
                                className="btn btn-orange myOrder-sure-receipt"
                                onClick={(e) => {this.sureReceipt(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                确认消费
                              </span>
                            </div>
                          ) : (
                            item.status == 3 && (
                              <div className="myOrder-list-bottom">
                                <span
                                  className="btn btn-orange myOrder-make-comment"
                                  onClick={(e) => {this.makeComment(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  去评价
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 2 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-takeout myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          className="myOrder-list-wrap"
                          style={convertLineStyleData(
                            'margin-bottom: 16rpx;' +
                            (item.status == 3 || item.status == 1
                              ? 'padding-bottom:0rpx;'
                              : '')
                          )}
                          onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                          data-franchisee={item.app_id}
                          data-id={item.order_id}
                          data-type="takeout"
                          key={item.order_id || index}
                        >
                          <div className="myOrder-goods-list">
                            {index == 0 && (
                              <React.Fragment>
                                {Array.isArray(item.goods_info) && item.goods_info.map((goods, index) => {
                                  return (
                                    <div key={goods.id || index}>
                                      <div className="dialog-block-item">
                                        {item.sub_shop_info && item.sub_shop_info.name ? (
                                          <img
                                            className="myOrder-goods-cover"
                                            src={item.sub_shop_info.logo}
                                            mode="aspectFill"
                                          />
                                        ) : (
                                          <img
                                            className="myOrder-goods-cover"
                                            src={takeoutInfo && takeoutInfo.cover}
                                            mode="aspectFill"
                                          />
                                        )}
                                        <div className="myOrder-takeout-Info">
                                          <div style={convertLineStyleData('font-size: 30rpx;font-weight: 400;height: 30rpx;')}>
                                            {(item.sub_shop_info && item.sub_shop_info.name) ||
                                              (takeoutInfo && takeoutInfo.title)}
                                            {item.status == 0 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size:26rpx;font-weight: normal;')}
                                              >
                                                待付款
                                              </span>
                                            ) : item.status == 8 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                待接单
                                              </span>
                                            ) : item.status == 1 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                待配送
                                              </span>
                                            ) : item.status == 2 &&
                                              (item.take_out_info.deliver_type ==
                                                0 ||
                                                item.take_out_info.deliver_type ==
                                                  '') ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                配送中
                                              </span>
                                            ) : item.status == 2 &&
                                              (item.take_out_info.deliver_type ==
                                                3 ||
                                                item.take_out_info.deliver_type ==
                                                  1) ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                {
                                                  transportStatus[
                                                    item.take_out_transport_order
                                                      .status
                                                  ]
                                                }
                                              </span>
                                            ) : item.status == 3 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                待评价
                                              </span>
                                            ) : item.status == 4 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                退款审核中
                                              </span>
                                            ) : item.status == 5 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                正在退款中
                                              </span>
                                            ) : item.status == 6 ? (
                                              <span
                                                className="takeout-order-status pull-right"
                                                style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                              >
                                                已完成
                                              </span>
                                            ) : (
                                              item.status == 7 && (
                                                <span
                                                  className="takeout-order-status pull-right"
                                                  style={convertLineStyleData('font-size: 26rpx;font-weight: normal;')}
                                                >
                                                  已关闭
                                                </span>
                                              )
                                            )}
                                          </div>
                                          <div style={convertLineStyleData('font-size: 22rpx;margin-top: 12rpx;margin-bottom:32rpx;color: #999;')}>
                                            {item.add_time}
                                          </div>
                                        </div>
                                        {item.transport &&
                                          item.transport.statusCode >= 2 && (
                                            <Map
                                              onClick={this.mapDetail}
                                              data-lat={
                                                item.transport.transporterLat
                                              }
                                              data-lng={
                                                item.transport.transporterLng
                                              }
                                              style={convertLineStyleData('margin: 10rpx auto;')}
                                              longitude={
                                                item.transport.transporterLng
                                              }
                                              latitude={
                                                item.transport.transporterLat
                                              }
                                              scale="18"
                                              markers={marker}
                                              showLocation={true}
                                            ></Map>
                                          )}
                                        {goods.is_presell == 1 ? (
                                          <div className="presell-order-bottom">
                                            <span>
                                              {'定金已支付：¥ ' +
                                                item.form_data.total_bargain}
                                            </span>
                                            <span>
                                              {'尾款已支付：¥ ' +
                                                item.form_data
                                                  .total_final_payment}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="takeout-goods-detail">
                                            <div className="myOrder-takeout-title">
                                              {goods.goods_name +
                                                (goodsNum > 1 ? '等' : '') +
                                                goodsNum +
                                                '件商品'}
                                              <span
                                                className="pull-right"
                                                style={convertLineStyleData('font-weight: 500;color: #333;')}
                                              >
                                                <span style={convertLineStyleData('margin: 0 3px;font-size: 22rpx;font-weight: normal;')}>
                                                  ¥
                                                </span>
                                                {item.total_price}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {item.status == 0 && (
                                          <div style={convertLineStyleData('text-align: right;')}>
                                            <span
                                              className="btn myOrder-apply-drawback"
                                              onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              style={convertLineStyleData('padding:1px 10px;font-size:24rpx;border-radius: 4px;margin-right:23rpx;')}
                                            >
                                              取消订单
                                            </span>
                                            <span
                                              className="btn btn-orange myOrder-make-comment"
                                              onClick={this.payOrder}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              data-price={item.total_price}
                                              style={convertLineStyleData('padding: 0px 10px;font-size: 24rpx;')}
                                            >
                                              去支付
                                            </span>
                                          </div>
                                        )}
                                        {((item.status == 1 &&
                                          !item.take_out_info
                                            .transport_shop_id) ||
                                          item.status == 8) && (
                                          <div className="myOrder-list-bottom">
                                            <span
                                              className="btn myOrder-apply-drawback"
                                              onClick={this.toCancelOrder}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              data-deliver={
                                                item.take_out_info.deliver_type
                                              }
                                              style={convertLineStyleData('padding:1px 10px;font-size:24rpx;border-radius: 4px;')}
                                            >
                                              取消订单
                                            </span>
                                          </div>
                                        )}
                                        {item.status == 3 && (
                                          <div style={convertLineStyleData('text-align: right;')}>
                                            <span
                                              className="btn myOrder-apply-drawback"
                                              onClick={(e) => {this.orderDelete(e);e.stopPropagation()}}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              style={convertLineStyleData('padding:1px 10px;font-size:24rpx;border-radius: 4px;margin-right:16rpx;')}
                                            >
                                              删除订单
                                            </span>
                                            <span
                                              className="btn btn-orange myOrder-make-comment"
                                              onClick={(e) => {this.takeoutMakeComment(e);e.stopPropagation()}}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              style={convertLineStyleData('padding: 0px 10px;font-size: 24rpx;')}
                                            >
                                              去评价
                                            </span>
                                          </div>
                                        )}
                                        {item.status == 4 && (
                                          <div style={convertLineStyleData('text-align: right;')}>
                                            <span
                                              className="btn myOrder-apply-drawback"
                                              onClick={this.cancelRefund}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              style={convertLineStyleData('padding:1px 10px;font-size:24rpx;border-radius: 4px;')}
                                            >
                                              撤销申请
                                            </span>
                                          </div>
                                        )}
                                        {item.status == 5 && (
                                          <div style={convertLineStyleData('text-align: right;')}>
                                            <span
                                              className="btn myOrder-apply-drawback"
                                              onClick={(e) => {this.receiveDrawback(e);e.stopPropagation()}}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              style={convertLineStyleData('padding:1px 10px;font-size:24rpx;border-radius: 4px;')}
                                            >
                                              收到退款
                                            </span>
                                          </div>
                                        )}
                                        {(item.status == 6 ||
                                          item.status == 7) && (
                                          <div style={convertLineStyleData('text-align: right;')}>
                                            <span
                                              className="btn myOrder-apply-drawback"
                                              onClick={(e) => {this.orderDelete(e);e.stopPropagation()}}
                                              data-franchisee={item.app_id}
                                              data-id={item.order_id}
                                              style={convertLineStyleData('padding:1px 10px;font-size:24rpx;border-radius: 4px;')}
                                            >
                                              删除订单
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )
                                })}
                              </React.Fragment>
                            )}
                            {item.goods_info && item.goods_info[0] && item.goods_info[0].is_presell == 1 ? (
                              <div className="presell-order-bottom">
                                <span style={convertLineStyleData('margin-right:20rpx;')}>
                                  {'定金已支付：¥ ' + item.total_bargain}
                                </span>
                                <span>
                                  {'尾款已支付：¥ ' + item.total_final_payment}
                                </span>
                              </div>
                            ) : (
                              <div className="goods-order-bottom">
                                <span className="myOrder-list-count">
                                  {'共' + item.goods_num + '件商品'}
                                </span>
                                {item.is_integral != '1' && (
                                  <span>
                                    合计：
                                    <span className="total-price">
                                      {'¥' + item.original_price}
                                    </span>
                                  </span>
                                )}
                                {item.is_integral == '1' && (
                                  <span>
                                    合计：
                                    {((item.original_price != 0 &&
                                      item.original_price != '0.00') ||
                                      !item.total_integral ||
                                      item.total_integral == 0) && (
                                      <span className="myOrder-pay-price">
                                        {'¥' + item.original_price}
                                      </span>
                                    )}
                                    {item.total_integral &&
                                      item.total_integral != 0 &&
                                      item.original_price != 0 &&
                                      item.original_price != '0.00' && (
                                        <span className="myOrder-pay-price">
                                          +
                                        </span>
                                      )}
                                    {item.total_integral && (
                                      <span className="myOrder-pay-price">
                                        {item.total_integral + '积分'}
                                      </span>
                                    )}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 3 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-tostore myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          className="myOrder-list-wrap"
                          key={item.order_id || index}
                          onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                          data-franchisee={item.app_id}
                          data-id={item.order_id}
                          data-type="tostore"
                        >
                          <div className="dialog-block-item myOrder-tostore-top">
                            <span className="dialog-block-time">
                              {'下单时间: ' + item.add_time}
                            </span>
                            <span className="pull-right tostore-see-detail">
                              查看详情
                            </span>
                          </div>
                          {item.sub_shop_info && item.sub_shop_info.name && (
                            <div className="myOrder-franchisee-name">
                              {item.sub_shop_info.name}
                            </div>
                          )}
                          <div className="myOrder-goods-list">
                            <React.Fragment>
                              {Object.values(item.goods_info).map((goods, index) => {
                                return (
                                  index == 0 && <div key={goods.id || index}>
                                    <div className="dialog-block-item">
                                      {!!+goods.use_integral && (
                                        <div className="myOrder-goods-tips">
                                          <div className="myOrder-goods-tips-top">
                                            积
                                          </div>
                                          <div className="myOrder-goods-tips-left"></div>
                                          <div className="myOrder-goods-tips-right"></div>
                                        </div>
                                      )}
                                      <img
                                        className="myOrder-goods-cover"
                                        src={goods.cover}
                                        mode="aspectFill"
                                      />
                                      <div className="tostore-goods-detail">
                                        <div className="myOrder-tostore-title">
                                          <div style={convertLineStyleData('font-size: 28rpx;')}>
                                            {goods.goods_name}
                                          </div>
                                          {!!goods.model_value.length && (
                                            <div style={convertLineStyleData('color: #999;margin-top: 8rpx;line-height: 32rpx;')}>
                                              {goods.model_name.map(
                                                (item, index) => {
                                                  return (
                                                    <div key={index}>
                                                      {item +
                                                        ' : ' +
                                                        goods.model_value[
                                                          index
                                                        ]}
                                                    </div>
                                                  )
                                                }
                                              )}
                                            </div>
                                          )}
                                        </div>
                                        <div className="tostorePrice-num">
                                          <div style={convertLineStyleData('font-size: 30rpx')}>
                                            {goods.use_integral == 0 ? (
                                              <React.Fragment>
                                                <span>{'¥' + goods.price}</span>
                                              </React.Fragment>
                                            ) : (
                                              <React.Fragment>
                                                {(goods.price != '0.00' ||
                                                  !goods.use_integral ||
                                                  goods.use_integral == 0) && (
                                                  <span>
                                                    {'¥' + goods.price}
                                                  </span>
                                                )}
                                                {goods.use_integral &&
                                                  goods.use_integral != 0 &&
                                                  goods.price != '0.00' && (
                                                    <span>+</span>
                                                  )}
                                                {goods.use_integral && (
                                                  <span>
                                                    {goods.use_integral +
                                                      '积分'}
                                                  </span>
                                                )}
                                              </React.Fragment>
                                            )}
                                          </div>
                                          <div style={convertLineStyleData('color: #999;')}>
                                            {'×' + goods.num}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </React.Fragment>
                          </div>
                          <div className="myOrder-list-bottom">
                            <div>
                              {item.tostore_data && item.tostore_data.formatted_queue_num && (
                                <label className="pull-left">
                                  取餐号：
                                  <span>
                                    {item.tostore_data.formatted_queue_num}
                                  </span>
                                </label>
                              )}
                              <label>
                                <span className="myOrder-list-count">
                                  {'共' + item.goods_num + '件'}
                                </span>
                                {item.is_integral != '1' ? (
                                  <React.Fragment>
                                    <span>{'¥' + item.total_price}</span>
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {((item.original_price != '0.00' &&
                                      item.original_price != 0) ||
                                      !item.total_integral ||
                                      item.total_integral == 0) && (
                                      <span>{'¥' + item.original_price}</span>
                                    )}
                                    {item.original_price != '0.00' &&
                                      item.original_price != 0 &&
                                      item.total_integral &&
                                      item.total_integral != 0 && <span>+</span>}
                                    {item.total_integral &&
                                      item.total_integral != 0 && (
                                        <span>
                                          {item.total_integral + '积分'}
                                        </span>
                                      )}
                                  </React.Fragment>
                                )}
                                {item.status == 0 ? (
                                  <span className="tostore-order-status">
                                    待付款
                                  </span>
                                ) : item.status == 1 ? (
                                  <span className="tostore-order-status">
                                    等待商家确认
                                  </span>
                                ) : item.status == 2 ? (
                                  <span className="tostore-order-status">
                                    商家已确认
                                  </span>
                                ) : item.status == 3 ? (
                                  <span className="tostore-order-status">
                                    待评价
                                  </span>
                                ) : item.status == 4 ? (
                                  <span className="tostore-order-status">
                                    退款审核中
                                  </span>
                                ) : item.status == 5 ? (
                                  <span className="tostore-order-status">
                                    正在退款中
                                  </span>
                                ) : item.status == 6 ? (
                                  <span className="tostore-order-status">
                                    已完成
                                  </span>
                                ) : (
                                  item.status == 7 && (
                                    <span className="tostore-order-status">
                                      已关闭
                                    </span>
                                  )
                                )}
                              </label>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 5 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-transfer myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          className="myOrder-list-wrap"
                          key={item.order_id || index}
                          onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                          data-franchisee={item.app_id}
                          data-id={item.order_id}
                          data-type="transfer"
                        >
                          <div className="dialog-block-item">
                            <span className="dialog-block-time">
                              {item.add_time}
                            </span>
                            {item.status == 0 ? (
                              <span className="pull-right myOrder-order-status">
                                待付款
                              </span>
                            ) : item.status == 6 ? (
                              <span className="pull-right myOrder-order-status">
                                已完成
                              </span>
                            ) : (
                              item.status == 7 && (
                                <span className="pull-right myOrder-order-status">
                                  已关闭
                                </span>
                              )
                            )}
                          </div>
                          {item.sub_shop_info && item.sub_shop_info.name && (
                            <div className="myOrder-franchisee-name">
                              {item.sub_shop_info.name}
                            </div>
                          )}
                          <div className="myOrder-goods-list">
                            <React.Fragment>
                              {Array.isArray(item.goods_info) && item.goods_info.map((goods, index) => {
                                return (
                                  index == 0 && <div key={goods.id || index}>
                                    <div className="dialog-block-item">
                                      <div className="myOrder-goods-cover transfer-order-cover">
                                        <img
                                          src={item.app_info.app_logo}
                                        />
                                      </div>
                                      <div className="myOrder-goods-title">
                                        当面付订单
                                      </div>
                                      <div className="myOrder-goods-right">
                                        <div>
                                          ¥
                                          <span className="myOrder-goods-price">
                                            {goods.price}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </React.Fragment>
                            <div className="dialog-block-item myOrder-total-item">
                              {item.is_integral != '1' && (
                                <span>
                                  合计：
                                  <span className="myOrder-pay-price">
                                    {'¥' + item.total_price}
                                  </span>
                                </span>
                              )}
                              {item.is_integral == '1' && (
                                <span>
                                  合计：
                                  {((item.original_price != '0.00' &&
                                    item.original_price != 0) ||
                                    !item.total_integral ||
                                    item.total_integral == 0) && (
                                    <span className="myOrder-pay-price">
                                      {'¥' + item.original_price}
                                    </span>
                                  )}
                                  {item.total_integral &&
                                    item.total_integral != 0 &&
                                    item.original_price != 0 &&
                                    item.original_price != '0.00' && (
                                      <span className="myOrder-pay-price">+</span>
                                    )}
                                  {item.total_integral && (
                                    <span className="myOrder-pay-price">
                                      {item.total_integral + '积分'}
                                    </span>
                                  )}
                                </span>
                              )}
                              {/*  <text>合计：<text class="myOrder-pay-price" wx:if="{{item.original_price != '0.00'}}">¥{{ item.original_price }}</text><text wx:if="{{item.total_integral && item.total_integral != 0 && item.original_price != '0.00'}}" class="myOrder-pay-price">+</text><text wx:if="{{item.total_integral}}" class="myOrder-pay-price">{{item.total_integral}}积分</text></text>  */}
                            </div>
                            {item.status == 0 ? (
                              <div className="myOrder-list-bottom">
                                <span
                                  className="btn myOrder-cancel-order"
                                  onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  取消订单
                                </span>
                                <span
                                  className="btn btn-orange myOrder-pay-directly"
                                  onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  支付
                                </span>
                              </div>
                            ) : item.status == 1 ? (
                              <div className="myOrder-list-bottom">
                                <span
                                  className="btn myOrder-verification-code"
                                  onClick={(e) => {this.getWriteOffCodeBox(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  核销码
                                </span>
                                {!item.timeDiff && (
                                  <span
                                    className="btn myOrder-apply-drawback"
                                    onClick={(e) => {this.applyDrawback(e);e.stopPropagation()}}
                                    data-franchisee={item.app_id}
                                    data-id={item.order_id}
                                  >
                                    申请退款
                                  </span>
                                )}
                              </div>
                            ) : item.status == 2 ? (
                              <div className="myOrder-list-bottom">
                                {!item.timeDiff && (
                                  <span
                                    className="btn myOrder-apply-drawback"
                                    onClick={(e) => {this.applyDrawback(e);e.stopPropagation()}}
                                    data-franchisee={item.app_id}
                                    data-id={item.order_id}
                                  >
                                    申请退款
                                  </span>
                                )}
                                <span
                                  className="btn btn-orange myOrder-sure-receipt"
                                  onClick={(e) => {this.sureReceipt(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  确认消费
                                </span>
                              </div>
                            ) : (
                              item.status == 3 && (
                                <div className="myOrder-list-bottom">
                                  <span
                                    className="btn btn-orange myOrder-make-comment"
                                    onClick={(e) => {this.makeComment(e);e.stopPropagation()}}
                                    data-franchisee={item.app_id}
                                    data-id={item.order_id}
                                  >
                                    去评价
                                  </span>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 6 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          className="myOrder-list-wrap row-number-box"
                          key={item.order_id || index}
                          onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                          data-franchisee={item.app_id}
                          data-id={item.order_id}
                          data-type="rowNumber"
                        >
                          <div className="take-num-time">
                            <span>{'取号时间：' + item.add_time}</span>
                            <span className="pull-right ico-moon icon-rightarrow"></span>
                          </div>
                          <div className="myOrder-row-number-shop">
                            <img src={item.app_info && item.app_info.app_logo} />
                            <span>{item.app_info && item.app_info.app_name}</span>
                          </div>
                          <div className="row-num-content">
                            <span className="ico-moon icon-mine-row-number"></span>
                            {'我的排号：' + (item.line_up_data && (item.line_up_data.queue_num_name || '未排号'))}
                          </div>
                          <div className="row-num-content">
                            <span className="ico-moon icon-row-number-type"></span>
                            {'排号类型：' + (item.line_up_data && (item.line_up_data.line_up_type_data ? item.line_up_data.line_up_type_data.name : item.line_up_data.line_up_type_name))}
                          </div>
                          <div className="row-num-content">
                            <span className="ico-moon icon-row-number-wait"></span>
                            {'预计等待：' +
                              ((item.line_up_data && item.line_up_data.prepare_wait_time) > 0
                                ? (item.line_up_data.prepare_wait_time >
                                  toStoreSetting.max_display_time
                                    ? '>' + toStoreSetting.max_display_time
                                    : item.line_up_data.prepare_wait_time) +
                                  '分钟'
                                : '无需等待')}
                          </div>
                          <div className="myOrder-rowNum-bottom">
                            <span className="myOrder-list-price">
                              <span className="ico-moon icon-row-number-fee"></span>
                              {'排号费：¥' + item.original_price}
                            </span>
                            {item.status == 0 ? (
                              <span className="rowNum-order-status">待付款</span>
                            ) : item.status == 2 ? (
                              <span className="rowNum-order-status">待使用</span>
                            ) : item.status == 4 ? (
                              <span className="rowNum-order-status">
                                退款申请中
                              </span>
                            ) : item.status == 5 ? (
                              <span className="rowNum-order-status">退款中</span>
                            ) : item.status == 6 ? (
                              <span className="rowNum-order-status used-rowNum-order">
                                已使用
                              </span>
                            ) : (
                              item.status == 7 && (
                                <span className="rowNum-order-status">
                                  已失效
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 10 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="newAppointment myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div className="newAppointment-list-wrap" key={index}>
                          <div className="newAppointment-status">
                            {item.status == 0 ? (
                              <span>待付款</span>
                            ) : item.status == 1 ? (
                              <span>等待商家确认</span>
                            ) : item.status == 2 ? (
                              <span>待消费</span>
                            ) : item.status == 3 ? (
                              <span>待评价</span>
                            ) : item.status == 4 ? (
                              <span>退款审核中</span>
                            ) : item.status == 5 ? (
                              <span>正在退款中</span>
                            ) : item.status == 6 ? (
                              <span>已完成</span>
                            ) : (
                              item.status == 7 && <span>已关闭</span>
                            )}
                          </div>
                          <div
                            className="newAppointment-goods-list"
                            onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                            data-franchisee={item.app_id}
                            data-id={item.order_id}
                            data-type={
                              item.service && item.service.is_hotel_appointment == 1
                                ? 'hotel'
                                : 'newAppoint'
                            }
                          >
                            <div>
                              <div className="appointment-info">
                                <img src={item.goods_info && item.goods_info[0] && item.goods_info[0].cover} />
                                <div className="des">
                                  <div className="serve-title">
                                    <span>{item.goods_info && item.goods_info[0] && item.goods_info[0].goods_name}</span>
                                    <div className="ico-moon icon-rightarrow"></div>
                                  </div>
                                  {item.service && item.service.is_hotel_appointment == 1 ? (
                                    <div className="hotel-info">
                                      <div className="time-box">
                                        <div className="checkIn">
                                          入住
                                          <span>
                                            {item.newAppointmentData.start_date}
                                          </span>
                                          {item.newAppointmentData.start_day}
                                        </div>
                                        <div
                                          className="sLine"
                                          style={convertLineStyleData('margin:0 20rpx;')}
                                        ></div>
                                        <div className="ckeckOut">
                                          离店
                                          <span>
                                            {item.newAppointmentData.end_date}
                                          </span>
                                          {item.newAppointmentData.end_day}
                                        </div>
                                      </div>
                                      <div className="day-count">
                                        {'共' +
                                          item.newAppointmentData.count +
                                          '晚'}
                                      </div>
                                      <div className="price">
                                        <span>价格：</span>
                                        {'¥' +
                                          item.goods_info[0].price +
                                          ' x ' +
                                          item.goods_info[0].num}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="section">
                                      {item.newAppointmentData && item.newAppointmentData.serveInfo.map(
                                        (wrap, index) => {
                                          return (
                                            <div className="area" key={index}>
                                              <span>{wrap.label + '：'}</span>
                                              {wrap.value}
                                            </div>
                                          )
                                        }
                                      )}
                                      {item.newAppointmentData && !!item.newAppointmentData.providerList
                                        .length && (
                                        <div className="area">
                                          <span>
                                            {item.newAppointmentData
                                              .providerTitle + '：'}
                                          </span>
                                          {item.newAppointmentData.providerList.map(
                                            (wrap, index) => {
                                              return (
                                                <React.Fragment key={index}>
                                                  {wrap.name}
                                                </React.Fragment>
                                              )
                                            }
                                          )}
                                        </div>
                                      )}
                                      <div className="duration">
                                        <span>时间：</span>
                                        {item.newAppointmentData && item.newAppointmentData.duration +
                                          '分钟'}
                                      </div>
                                      <div className="arrival-time">
                                        <span>到店时间：</span>
                                        <span
                                          className={
                                            item.status == 3 || item.status == 6
                                              ? ''
                                              : 'arrival-detail-time'
                                          }
                                        >
                                          {item.newAppointmentData && item.newAppointmentData.toStoreTime +
                                            '-' +
                                            item.newAppointmentData
                                              .toStoreTimeEnd}
                                        </span>
                                      </div>
                                      <div className="price">
                                        <span>价格：</span>
                                        {'¥' +
                                          (item.goods_info && item.goods_info[0] && item.goods_info[0].price +
                                          ' x ' +
                                          item.goods_info[0].num)}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {item.status == 0 ? (
                            <div className="newAppointment-list-bottom">
                              <span
                                className="btn myOrder-pay-directly"
                                onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                data-type={
                                  (item.service && item.service.is_hotel_appointment == 1)
                                    ? 'hotel'
                                    : 'newAppoint'
                                }
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                支付
                              </span>
                            </div>
                          ) : item.status == 1 ? (
                            <div className="newAppointment-list-bottom">
                              <span
                                className="btn myOrder-verification-code"
                                onClick={this.toSeeQrcode}
                                data-enddate={item.newAppointmentData && item.newAppointmentData.endDate}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                <span className="ico-moon icon-new-appointment-qrcode"></span>
                                查看券码
                              </span>
                            </div>
                          ) : item.status == 2 ? (
                            <div className="newAppointment-list-bottom">
                              <span
                                className="btn myOrder-verification-code"
                                onClick={this.toSeeQrcode}
                                data-enddate={item.newAppointmentData && item.newAppointmentData.endDate}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                <span className="ico-moon icon-new-appointment-qrcode"></span>
                                查看券码
                              </span>
                            </div>
                          ) : item.status == 3 ? (
                            <div className="newAppointment-list-bottom grade">
                              <div>
                                {[1, 2, 3, 4, 5].map((item, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="ico-moon icon-star"
                                    ></div>
                                  )
                                })}
                              </div>
                              <span
                                className="btn myOrder-make-comment"
                                onClick={(e) => {this.makeComment(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                评分
                              </span>
                            </div>
                          ) : (
                            item.status == 6 && (
                              <div className="newAppointment-list-bottom grade">
                                <div className="graded">
                                  <span>我评</span>
                                  {[1, 2, 3, 4, 5].map((score, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className={
                                          'ico-moon icon-star ' +
                                          (score <= item.score ? 'orange' : '')
                                        }
                                      ></div>
                                    )
                                  })}
                                </div>
                                {item.status == 0 && (
                                  <div className="myOrder-list-bottom">
                                    <span
                                      className="btn myOrder-cancel-order"
                                      onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                      data-franchisee={item.app_id}
                                      data-id={item.order_id}
                                    >
                                      取消订单
                                    </span>
                                    <span
                                      className="btn btn-orange myOrder-pay-directly"
                                      onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                      data-franchisee={item.app_id}
                                      data-id={item.order_id}
                                      data-type="transfer"
                                    >
                                      支付
                                    </span>
                                  </div>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 8 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-transfer myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          className="myOrder-list-wrap"
                          key={item.order_id || index}
                          data-id={item.order_id}
                          data-type
                        >
                          <div>
                            <div className="dialog-block-item border-none">
                              <span>{item.add_time}</span>
                              {item.status == 0 && (
                                <span className="pull-right myOrder-order-status">
                                  待付款
                                </span>
                              )}
                              {item.status == 1 ? (
                                <span className="pull-right myOrder-order-status">
                                  已付款
                                </span>
                              ) : (
                                item.status == 7 && (
                                  <span className="pull-right myOrder-order-status">
                                    已关闭
                                  </span>
                                )
                              )}
                            </div>
                            <div className="paid-card-block">
                              <div className="img-block">
                                <img
                                  className="order-img"
                                  src={item.goods_info.cover}
                                />
                              </div>
                              <div className="block-right">
                                <div className="block-right-item">
                                  <div className="paid-card-name">
                                    {item.goods_info.goods_name}
                                  </div>
                                  <div className="paid-card-price">
                                    {item.goods_info.price}
                                  </div>
                                </div>
                                <div className="block-right-item">
                                  <div className="paid-card-combo">
                                    {item.goods_info.num > 1 && (
                                      <span>
                                        {item.goods_info.cNum + '个月组合套餐'}
                                      </span>
                                    )}
                                  </div>
                                  <div className="paid-card-num">
                                    {'x' + item.goods_info.num}
                                  </div>
                                </div>
                                <div className="total-calculation">
                                  合计:
                                  <span className="price">
                                    {'¥' + item.total_price}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {item.status == 0 && (
                              <div className="myOrder-list-bottom">
                                <span
                                  className="btn myOrder-cancel-order"
                                  onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  取消订单
                                </span>
                                <span
                                  className="btn btn-orange myOrder-pay-directly"
                                  onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                  data-type="transfer"
                                >
                                  支付
                                </span>
                              </div>
                            )}
                            {item.status != 0 && (
                              <div className="paid-card-bottom">
                                <div className="order-id">
                                  {'订单号: ' + item.order_id}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {
                currentGoodsType == 9 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-transfer myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div
                          className="myOrder-list-wrap"
                          key={item.order_id || index}
                          data-id={item.order_id}
                          data-type
                        >
                          <div>
                            <div className="dialog-block-item border-none">
                              <span className="dialog-block-time">
                                {item.add_time}
                              </span>
                              {item.status == 0 && (
                                <span className="pull-right myOrder-order-status">
                                  待付款
                                </span>
                              )}
                              {item.status == 1 && (
                                <span className="pull-right myOrder-order-status">
                                  已付款
                                </span>
                              )}
                              {item.status == 7 && (
                                <span className="pull-right myOrder-order-status">
                                  已关闭
                                </span>
                              )}
                            </div>
                            <div
                              className="paid-card-block"
                              onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                              data-franchisee={item.app_id}
                              data-id={item.order_id}
                              data-type="ExchangeCoupon"
                            >
                              <div className="img-block">
                                <img
                                  className="order-img"
                                  src={item.goods_info.logo}
                                />
                              </div>
                              <div className="block-right">
                                <div className="block-right-item">
                                  <div className="paid-card-name">
                                    {item.goods_info.goods_name}
                                  </div>
                                  <div className="paid-card-price">
                                    {item.goods_info.price}
                                  </div>
                                </div>
                                <div className="block-right-item">
                                  <div className="paid-card-combo">
                                    {item.goods_info.expire && (
                                      <span>{item.goods_info.expire}</span>
                                    )}
                                  </div>
                                  <div className="paid-card-num">x1</div>
                                </div>
                                <div className="total-calculation">
                                  合计:
                                  <span className="price">
                                    {'¥' + item.total_price}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {item.status == 0 && (
                              <div className="myOrder-list-bottom">
                                <span
                                  className="btn myOrder-cancel-order"
                                  onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  取消订单
                                </span>
                                <span
                                  className="btn btn-orange myOrder-pay-directly"
                                  onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                  data-type="transfer"
                                >
                                  支付
                                </span>
                              </div>
                            )}
                            {item.status == 1 && (
                              <div className="myOrder-list-bottom">
                                {item.coupon_type == 6 &&
                                  item.un_verify_times != 0 && (
                                    <span
                                      className="btn btn-grey myOrder-pay-directly"
                                      onClick={(e) => {this.goToUseStamps(e);e.stopPropagation()}}
                                      data-franchisee={item.app_id}
                                      data-couponid={item.user_coupon_id}
                                      data-type="transfer"
                                      data-untimes={item.un_verify_times}
                                    >
                                      核销码
                                    </span>
                                  )}
                              </div>
                            )}
                            {item.status != 1 && item.status != 0 && (
                              <div className="paid-card-bottom">
                                <div className="order-id">
                                  {'订单号: ' + item.order_id}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
              {/*  社区团购  */}
              {
                currentGoodsType == 21 &&
                <div className="scrollContainer">
                  <ScrollView
                    className="myOrder-ebusiness myOrder-content-container"
                    scroll-y="true"
                    lowerThreshold="10"
                    bindscrolltolower={this.scrollToListBottom}
                  >
                    {orderLists.map((item, index) => {
                      return (
                        <div className="myOrder-list-wrap" key={item.order_id || index}>
                          <div className="dialog-block-item">
                            {item.is_pay_on_delivery == 1 && (
                              <span className="cash-delivery">货到付款</span>
                            )}
                            <span className="add-time">{item.add_time}</span>
                            {item.status == 0 ? (
                              <span className="pull-right myOrder-order-status">
                                待付款
                              </span>
                            ) : item.status == 1 ? (
                              <span className="pull-right myOrder-order-status">
                                待发货
                              </span>
                            ) : item.status == 2 ? (
                              <span className="pull-right myOrder-order-status">
                                配送中
                              </span>
                            ) : item.status == 3 ? (
                              <span className="pull-right myOrder-order-status">
                                待评价
                              </span>
                            ) : item.status == 4 ? (
                              <span className="pull-right myOrder-order-status">
                                {item.is_pay_on_delivery == 1
                                  ? '审核中'
                                  : '退款审核中'}
                              </span>
                            ) : item.status == 5 ? (
                              <span className="pull-right myOrder-order-status">
                                正在退款中
                              </span>
                            ) : item.status == 6 ? (
                              <span className="pull-right myOrder-order-status">
                                已完成
                              </span>
                            ) : item.status == 7 ? (
                              <span className="pull-right myOrder-order-status">
                                已关闭
                              </span>
                            ) : (
                              item.status == 10 && (
                                <span className="pull-right myOrder-order-status">
                                  待提货
                                </span>
                              )
                            )}
                          </div>
                          {item.sub_shop_info && item.sub_shop_info.name && (
                            <div className="myOrder-franchisee-name">
                              {item.sub_shop_info.name}
                            </div>
                          )}
                          <div
                            className="myOrder-goods-list"
                            onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                            data-franchisee={item.app_id}
                            data-id={item.order_id}
                            data-type="communityGroup"
                          >
                            {Array.isArray(item.goods_info) && item.goods_info.map((goods, index) => {
                              return (
                                <div key={goods.id || index}>
                                  <div className="dialog-block-item">
                                    <img
                                      className="myOrder-goods-cover"
                                      src={goods.cover}
                                    />
                                    <div className="myOrder-goods-title">
                                      {!!+goods.is_benefit_goods && (
                                        <span className="goods-gift">赠品</span>
                                      )}
                                      {!!+goods.is_vip_goods && (
                                        <span className="goods-gift">会员价</span>
                                      )}
                                      {goods.goods_name}
                                    </div>
                                    {!goods.is_benefit_goods && (
                                      <div className="myOrder-goods-right">
                                        <div>
                                          {goods.price != '0.00' && (
                                            <span className="myOrder-goods-price">
                                              {'¥' + goods.price}
                                            </span>
                                          )}
                                          {goods.use_integral &&
                                            goods.use_integral != 0 &&
                                            goods.price != '0.00' && (
                                              <span>+</span>
                                            )}
                                          {goods.use_integral && (
                                            <span>
                                              {goods.use_integral + '积分'}
                                            </span>
                                          )}
                                        </div>
                                        <div>
                                          ×
                                          <span className="myOrder-goods-count">
                                            {goods.num}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div className="dialog-block-item myOrder-total-item">
                            <span>
                              合计：
                              <span className="myOrder-pay-price">
                                {'¥' + item.original_price}
                              </span>
                            </span>
                          </div>
                          {item.status == 0 ? (
                            <div className="myOrder-list-bottom">
                              <span
                                className="btn myOrder-cancel-order"
                                onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                取消订单
                              </span>
                              <span
                                className="btn btn-orange myOrder-pay-directly"
                                onClick={(e) => {this.goToOrderDetail(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                                data-type="communityGroup"
                              >
                                支付
                              </span>
                            </div>
                          ) : item.status == 1 ? (
                            <div className="myOrder-list-bottom">
                              {/*  <text class="btn myOrder-cancel-order" data-delivery="{{item.is_pay_on_delivery}}" catchtap="applyDrawback" data-franchisee="{{ item.app_id }}" data-id="{{ item.order_id }}">{{item.is_pay_on_delivery == 1 ? '取消订单' : '申请退款'}}</text>  */}
                            </div>
                          ) : item.status == 2 ? (
                            <div className="myOrder-list-bottom">
                              {/*  <text class="btn btn-orange myOrder-sure-receipt" bindtap="sureReceipt" data-franchisee="{{ item.app_id }}" data-id="{{ item.order_id }}">确认收货</text>  */}
                              {/*  <text class="btn myOrder-cancel-order" data-delivery="{{item.is_pay_on_delivery}}" catchtap="applyDrawback" data-franchisee="{{ item.app_id }}" data-id="{{ item.order_id }}">{{item.is_pay_on_delivery == 1 ? '取消订单' : '申请退款'}}</text>  */}
                            </div>
                          ) : item.status == 3 ? (
                            <div className="myOrder-list-bottom">
                              <span
                                className="btn btn-orange myOrder-make-comment"
                                onClick={(e) => {this.makeComment(e);e.stopPropagation()}}
                                data-franchisee={item.app_id}
                                data-id={item.order_id}
                              >
                                去评价
                              </span>
                            </div>
                          ) : (
                            item.status == 10 && (
                              <div className="myOrder-list-bottom">
                                <span
                                  className="btn myOrder-verification-code"
                                  onClick={(e) => {this.getWriteOffCodeBox(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  核销码
                                </span>
                                <span
                                  className="btn btn-orange myOrder-sure-receipt"
                                  onClick={(e) => {this.sureReceipt(e);e.stopPropagation()}}
                                  data-franchisee={item.app_id}
                                  data-id={item.order_id}
                                >
                                  确认收货
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      )
                    })}
                    <div hidden={!noMore} className="noMoreNewDataTip">
                      已经没有新数据了
                    </div>
                  </ScrollView>
                </div>
              }
            </div>
          </div>
        </div>
        {/*  核销码  */}
        {showWriteOffCodeBox && (
          <div
            className="verification-code"
            onClick={this.hideWriteOffCodeBox}
          >
            <div className="verification-code-tips">
              向商家出示二维码或核销码后即可消费
            </div>
            <div className="verification-image-box">
              <img className="verification-code-img" src={codeImgUrl} />
              {codeStatus == 1 && (
                <div className="verification-code-finished">
                  <div>已核销</div>
                </div>
              )}
            </div>
            <div className="verification-code-text">
              <span>核销码：</span>
              <span>{codeNum}</span>
            </div>
          </div>
        )}
        {showGoodsPickBox && (
          <div
            className="filter-goods-pick-mask"
            onClick={this.hideGoodsPick}
            onTouchMove={this.stopPropagation}
          >
            <div
              className="filter-goods-pick-box"
              onClick={this.stopPropagation}
            >
              <div
                onClick={this.selectGoodsPick}
                data-type="0"
                className={selectGoodsPickIndex == '0' ? 'selected' : ''}
              >
                全部
                {selectGoodsPickIndex == '0' && (
                  <span className="pull-right ico-moon icon-gou"></span>
                )}
              </div>
              <div
                onClick={this.selectGoodsPick}
                data-type="1"
                className={selectGoodsPickIndex == '1' ? 'selected' : ''}
              >
                快递
                {selectGoodsPickIndex === '1' && (
                  <span className="pull-right ico-moon icon-gou"></span>
                )}
              </div>
              <div
                onClick={this.selectGoodsPick}
                data-type="2"
                className={selectGoodsPickIndex == '2' ? 'selected' : ''}
              >
                同城配送
                {selectGoodsPickIndex === '2' && (
                  <span className="pull-right ico-moon icon-gou"></span>
                )}
              </div>
              <div
                onClick={this.selectGoodsPick}
                data-type="3"
                className={selectGoodsPickIndex == '3' ? 'selected' : ''}
              >
                上门自提
                {selectGoodsPickIndex === '3' && (
                  <span className="pull-right ico-moon icon-gou"></span>
                )}
              </div>
              <div
                onClick={this.selectGoodsPick}
                data-type="4"
                className={selectGoodsPickIndex == '4' ? 'selected' : ''}
              >
                堂食点餐
                {selectGoodsPickIndex === '4' && (
                  <span className="pull-right ico-moon icon-gou"></span>
                )}
              </div>
            </div>
          </div>
        )}
        <Modal
          visible={!hiddenmodalput}
          transparent
          title="请输入本次核销次数"
          maskClosable={true}
          platform="'ios'"
          footer={[{
            text: '取消',
            onPress: this.cancel,
          }, {
            text: '确认',
            onPress: this.confirm,
          }]}
        >
          <input
            type="number"
            placeholder="请输入本次核销次数"
            maxLength="6"
            onChange={this.addLabelInput}
            value={addLabelText}
            style={{
              background:'#F5F5F5',
              height: '.76rem',
              borderRadius:'.10rem',
              padding: '.10rem .10rem',
              boxSizing: 'border-box',
              border: 0
            }}
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/my-order/MyOrder.jsx